export default function DS_Certificate() {
  return <div>DS_Certificate Component</div>;
}
